export const updates = [
  {
    id: "codex-and-developer-docs", date: "2026-10-28", category: "开发者", kicker: "客户端接入 · 开发文档",
    title: "把 LumaNova 接入 Codex",
    summary: "LumaNova API Key 已完成 Codex 接入实测。通过 Responses 协议连接 deepseek-flash，并可在网页端查看实际用量。全新开发文档同步上线，集中介绍 API 调用、三种内置工具和客户端配置。",
    docsSection: "codex",
    highlights: ["新增 Codex 接入指南，提供模型目录下载与完整配置示例。", "开发文档覆盖 API、联网搜索、图片生成和编辑。", "在网页查看实际用量；配置前先备份，便于恢复官方环境。"],
    features: [
      { name: "Codex 接入", description: "准备 models.json，备份并合并用户目录下的 config.toml，通过 LumaNova 的 Responses 地址连接模型。" },
      { name: "完整开发文档", description: "快速开始、Responses API、内置工具、Codex 接入与排错分别成章，示例支持复制，文档支持 Markdown 下载。" },
      { name: "用量可查", description: "API 调用产生的实际消耗可在网页账号菜单和用量页查看，无需另建一套用量账户。" },
    ],
    sectionTitle: "开始之前",
    notes: ["先备份 ~/.codex/config.toml；已有同名配置请修改原项，不要直接覆盖整份文件或重复追加。", "模型目录提供 deepseek-flash 与 deepseek-v4-pro 配置，接入实测以 deepseek-flash 为准；客户端版本与模型能力以实际支持为准。", "教程默认关闭 Codex 联网搜索。客户端工具与 Luma 内置托管工具是两类调用，不保证所有 Codex 功能仅替换地址即可使用。"],
    billing: ["使用自己的 LumaNova API Key，消耗计入账号的 API 用量；最终以后台结算为准。", "查看完整接入指南可获取模型目录文件、配置步骤和恢复官方环境的方法。"],
  },
  {
    id: "weekly-usage-and-key-management",
    date: "2026-10-28", category: "产品", kicker: "用量与订阅 · 全新升级",
    title: "每个周期的用量，一目了然",
    summary: "用量页升级为共享周额度与独立短周期。所有档位统一以百分比展示剩余额度，并明确显示下一次重置时间。",
    highlights: ["7 天总额共享，网页与 API 的 5 小时额度独立。", "图片改为每日额度，北京时间零点重置。", "支持删除 API 密钥，删除后立即停止接受新请求。"],
    features: [
      { name: "共享的 7 天额度", description: "网页对话与 API 调用共同计入周总额。首次实际消耗后开始连续 7 天计时，而非固定周一重置。" },
      { name: "独立的 5 小时窗口", description: "网页与 API 分别计时，首次实际使用后固定重置时间；尚未使用时，重置时间随当前时间顺延。" },
      { name: "每日图片额度", description: "图片按北京时间自然日计数，次日零点重置。更高的订阅档位提供更充足的图片额度。" },
    ],
    sectionTitle: "周期与规则",
    notes: ["已开始的最后一次任务不会因为执行中触及 Token 上限而被打断，实际消耗仍会完整计入共享周额度。", "共享周额度用尽后，即使短周期尚有剩余，也无法继续发起模型请求。", "用量页只显示剩余百分比与具体重置时间；API 密钥可在密钥管理中确认删除。"],
    billing: ["新用量规则上线时，所有档位从新的 Token 窗口开始，订阅等级、到期时间保持不变。", "升级订阅可获得更多额度；额度耗尽时，网页与 API 会在调用上游模型前拦截新请求。"],
  },
  {
    id: "responses-hosted-tools",
    date: "2026-10-27",
    dateLabel: "2026 年 10 月 27 日",
    category: "API",
    title: "一次 API 调用，从理解到执行",
    summary: "Responses API 新增 Luma 内置工具。使用自己的 Luma API Key，让模型理解需求、调用工具，再把结果带回同一次请求。",
    highlights: ["联网搜索：整理搜索词，检索后带来源回答。", "图片生成：自然语言转为生图提示词并执行。", "图片编辑：携带参考图，按要求修改画面。"],
    features: [
      { name: "联网搜索", description: "模型整理搜索词，调用 Luma 联网搜索，并结合实际检索结果组织回答与来源链接。" },
      { name: "图片生成", description: "用自然语言描述画面，模型整理生图提示词后执行生成，返回图片与结果说明。" },
      { name: "图片编辑", description: "提供可访问的图片 URL 和修改要求，模型从本次请求的参考图中选择目标并执行编辑。" },
    ],
    notes: [
      "无状态调用：不会自动保存跨请求会话。继续处理上一张图时，请在本次请求中携带相关历史和图片 URL。",
      "本次内置工具能力通过 /v1/responses 提供；原有 Chat Completions 模型调用方式保持不变。",
      "图像工具每次请求最多生成或编辑一张图片，可与本次请求中的其他工具步骤衔接。",
    ],
    billing: [
      "API 与网页的 5 小时额度独立，并共用 7 天总额度；图片生成、编辑与网页 Chatbot 共用每日图片额度。",
      "搜索工具不额外收费，模型解析、工具调用和结果整理产生的 Token 按实际用量计数。",
      "技术故障导致的失败不扣 Token 或图片次数；图片服务明确的安全拦截不扣图片次数，已产生的模型 Token 正常计数。",
    ],
  },
];

export const imageExample = {
  model: "deepseek-flash",
  input: "生成一张水彩风格的山间小屋，清晨阳光，无文字。",
  store: false,
  tools: [{ type: "image_generation", action: "generate" }],
  tool_choice: { type: "image_generation" },
};

export const toolExamples = [
  {
    id: "search", name: "联网搜索", label: "web_search",
    description: "在 tools 中声明 web_search。下面的 tool_choice 要求执行搜索；改为 auto 时，由模型判断是否需要搜索。检索词由模型根据当前输入整理。",
    payload: { model: "deepseek-flash", input: "搜索最近的 Python 版本发布信息，并提供来源链接。", store: false, stream: false,
      tools: [{ type: "web_search" }], tool_choice: { type: "web_search" },
      include: ["web_search_call.action.sources"] },
    result: "在 output 中读取 web_search_call 的检索记录和来源，以及 message 中的最终回答。来源来自实际搜索结果，而非模型虚构的链接。",
  },
  {
    id: "generate", name: "图片生成", label: "image_generation / generate",
    description: "声明 image_generation 并指定 action: generate。输入自然语言需求，模型会整理图片提示词，再调用 Luma 的生图服务，而不是把文字模型名当作图片模型名。",
    payload: { ...imageExample, stream: false },
    result: "在 output 中查找 status 为 completed 的 image_generation_call。result 为图片 Base64；image_url 是 Luma 额外提供的成图地址。message 包含结果说明。",
  },
  {
    id: "edit", name: "图片编辑", label: "image_generation / edit",
    description: "仍使用 image_generation，将 action 改为 edit。在 input 中同时传入 input_text 和 input_image；把示例 URL 换成你自己的、无需登录即可下载的真实图片地址。",
    payload: { model: "deepseek-flash", store: false, stream: false,
      input: [{ role: "user", content: [
        { type: "input_text", text: "把这张图片改成水彩风格，保留主体与构图，不添加文字。" },
        { type: "input_image", image_url: "https://example.com/reference.png" },
      ] }], tools: [{ type: "image_generation", action: "edit" }], tool_choice: { type: "image_generation" } },
    result: "编辑结果同样位于 image_generation_call 中。当前参考图使用公开 HTTP(S) URL，不支持 file_id 或 data URL。没有明确参考图时，需要补充图片，不能只说“修改上一张”。",
  },
];
